import { render, staticRenderFns } from "./ManufacturersTable.vue?vue&type=template&id=21da2dd4"
import script from "./ManufacturersTable.vue?vue&type=script&lang=js"
export * from "./ManufacturersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports